import React from "react";
import { RiQuestionAnswerLine } from "@remixicon/react";
import { WorkflowServiceAction } from "../../../../__generated__/api";
import Button from "../../../theme/button/Button";
import { ACTION_ICON_MAP } from "../../workflow/node-mappings";
import Styles from "./ActionTag.module.scss";
import Badge from "../../../theme/badge/Badge";
import Text from "../../../theme/text/Text";
import ExpandingSection from "../../../expanding-section/ExpandingSection";
import Icon from "../../../theme/icon/Icon";

interface ActionTagProps {
    tag: string;
    actions: WorkflowServiceAction[];
    showServiceConfiguration: (action: WorkflowServiceAction) => void;
    isDefaultExpanded: boolean;
}

export default function ActionTag({
    tag, actions, showServiceConfiguration, isDefaultExpanded,
}: ActionTagProps) {
    const handleServiceClick = (action: WorkflowServiceAction) => {
        showServiceConfiguration(action);
    };

    return (
        <ExpandingSection
            title={(
                <div className={Styles["card-title"]}>
                    <Text textVariant="body-2-medium" colorVariant="body-secondary">{tag}</Text>
                    <Badge
                        size="small"
                        isRounded
                        variant="counter"
                    >
                        <Text textVariant="caption-medium" colorVariant="body-secondary">
                            {actions.length}
                        </Text>
                    </Badge>
                </div>
            )}
            iconVariant="small"
            defaultExpanded={isDefaultExpanded}
            buttonClassName={Styles["expanding-tags-section-button"]}
            className={Styles["expanding-tags-section"]}
            defaultCardClassName={Styles["expanding-tags-section-background"]}
            shouldWatchExpansion
        >
            {actions.map(action => {
                const ActionIcon = ACTION_ICON_MAP[action.id as keyof typeof ACTION_ICON_MAP] ?? RiQuestionAnswerLine;

                return (
                    <Button
                        key={action.id}
                        className={Styles["action-button"]}
                        onClick={() => handleServiceClick(action)}
                        variant="none"
                        size="small"
                        prefixIcon={<Icon size="small" variant="default" icon={<ActionIcon />} />}
                    >
                        <Text textVariant="body-1-regular">{action.name}</Text>
                    </Button>
                );
            })}
        </ExpandingSection>
    );
}
